import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { CartModel } from "@insite/client-framework/Types/ApiModels";
import {
    DiscrepancyCollectionParam,
    DiscrepancyCollectionResult,
    DiscrepancyDetailsResult,
} from "@tKgpco/Services/DiscrepancyService";
import { MessageCollectionModel } from "@tKgpco/Services/LoadMessageCollection";
import { DiscrepancyHistoryState } from "@tKgpco/Store/Data/DiscrepancyHistory/DiscrepancyState";
import { Draft } from "immer";

const initialState: DiscrepancyHistoryState = {
    isLoading: false,
    discrepancyCollection: null,
    discrepancyCollectionParams: {
        page: 1,
    },
    isFilterOpen: false,
    discrepancyDetailsCollection: null,
    discrepancyMessagesCollection: null,
};

const reducer = {
    "Custom/DiscrepancyHistory/BeginLoadDiscrepancyCollection": (
        draft: Draft<DiscrepancyHistoryState>,
        action: { params: DiscrepancyCollectionParam },
    ) => {
        draft.isLoading = true;
        draft.discrepancyCollectionParams = action.params;
        draft.discrepancyCollection = null;
    },

    "Custom/DiscrepancyHistory/CompleteLoadDiscrepancyCollection": (
        draft: Draft<DiscrepancyHistoryState>,
        action: { result: DiscrepancyCollectionResult },
    ) => {
        draft.isLoading = false;
        draft.discrepancyCollection = action.result;
    },
    "Custom/DiscrepancyHistory/ToggleFiltersOpen": (draft: Draft<DiscrepancyHistoryState>) => {
        draft.isFilterOpen = !draft.isFilterOpen;
    },
    "Custom/DiscrepancyHistory/ClearParameter": (draft: Draft<DiscrepancyHistoryState>) => {
        draft.discrepancyCollectionParams = {
            ...initialState.discrepancyCollectionParams,
        };
    },
    "Custom/DiscrepancyHistory/BeginLoadDiscrepancyDetailsCollection": (draft: Draft<DiscrepancyHistoryState>) => {
        draft.isLoading = true;
        draft.discrepancyDetailsCollection = null;
        draft.discrepancyMessagesCollection = null;
    },
    "Custom/DiscrepancyHistory/CompleteLoadDiscrepancyDetailsCollection": (
        draft: Draft<DiscrepancyHistoryState>,
        action: { result: DiscrepancyDetailsResult },
    ) => {
        draft.isLoading = false;
        draft.discrepancyDetailsCollection = action.result;
    },
    "Custom/DiscrepancyHistory/CompleteLoadDiscrepancyMessages": (
        draft: Draft<DiscrepancyHistoryState>,
        action: { collection: MessageCollectionModel[] },
    ) => {
        draft.isLoading = false;
        draft.discrepancyMessagesCollection = action.collection;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
